import { SafeHtml } from './_pipe/safe-html.pipe';
import { CmsFrontComponent } from './views/cms/cms-front/cms-front.component';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

import { AgmCoreModule } from '@agm/core';
import { AppComponent } from './app.component';

// Import containers
import { DefaultLayoutComponent, LoaderModule} from './containers';

import { P404Component } from './views/error/404.component';
import { P403Component } from './views/error/403.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';
import { RegisterComponent } from './views/register/register.component';
import { ResetPasswordComponent } from './views/reset-password/reset-password.component';

const APP_CONTAINERS = [
  DefaultLayoutComponent
];

import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule,
} from '@coreui/angular';

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
// import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts';

import { AuthGuard } from './_guards/auth.guard';
import { JwtInterceptor } from './_helpers/jwt.interceptor';
import { ErrorInterceptor } from './_helpers/error.interceptor';

import { ModalModule } from 'ngx-bootstrap/modal';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { TreeviewModule } from 'ngx-treeview';
import { NgxPermissionsModule } from 'ngx-permissions';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MapComponent } from './views/map/map.component';
import { ConnectionListComponent } from './modals/connection-list.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { OrderConnectionListComponent } from './modals/order-list.component';
import { SharedModule } from './_module/shared.module';
import { AccountActivateComponent } from './views/account-activate/account-activate.component';
import { VerifyOTPComponent } from './views/verify-otp/verify-otp.component';
import { AccountActiveTempComponent } from './views/account-active-temp/account-active-temp.component';
import { BatchManagementComponent } from './views/manage-category/batch-management/batch-management.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { OrdersExtendedModalComponent } from './views/dashboard/order-analytics/orders-extended-modal/orders-extended-modal.component';
import { InventoryExtendedModalComponent } from './views/dashboard/inventory-analytics/inventory-extended-modal/inventory-extended-modal.component';
import { PatientExtendedModalComponent } from './views/dashboard/patient-analytics/patient-extended-modal/patient-extended-modal.component';
import { PurchaseExtendedModalComponent } from './views/dashboard/purchase-analytics/purchase-extended-modal/purchase-extended-modal.component';
import { ItemWiseMarginComponent } from './views/dashboard/purchase-analytics/item-wise-margin/item-wise-margin.component';
import { ItemwisepurchaseComponent } from './views/manage-category/itemwisepurchase/itemwisepurchase.component';

import { HospitalInactiveExtendedModalComponent } from './views/dashboard/patient-analytics/hospital-inactive-extended-modal/hospital-inactive-extended-modal.component';
import { HeightvaluepatientHospitalComponent } from './views/dashboard/patient-analytics/heightvaluepatient-hospital/heightvaluepatient-hospital.component';
import { AppointmentManagementComponent } from './views/appointment-management/appointment-management.component';

import { NewtimepickerModule } from './views/newtimepicker/newtimepicker.module';
import { LabsManagementComponent } from './views/labs-management/labs-management.component';
import { DiagnosticManagementComponent } from './views/diagnostic-management/diagnostic-management.component';
// import { WhatsappManagementComponent } from './views/whatsapp-management/whatsapp-management.component';



const BASE_MODULES = [CommonModule, FormsModule, ReactiveFormsModule];

// export function HttpLoaderFactory(http: HttpClient) {
//   return new TranslateHttpLoader(http);
// }

@NgModule({
  imports: [
    NewtimepickerModule,
    BrowserModule,
    ...BASE_MODULES,
    HttpClientModule,
    AppRoutingModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    AppFooterModule,
    AppHeaderModule,
    AppSidebarModule,
    PerfectScrollbarModule,
    BsDropdownModule.forRoot(),
    // BsDatepickerModule.forRoot(),
    BrowserAnimationsModule,
    TabsModule.forRoot(),
    ChartsModule,
    ModalModule.forRoot(),
    NgbModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      closeButton: true,
      preventDuplicates: true,
    }), // ToastrModule added
    TreeviewModule.forRoot(),
    NgxPermissionsModule.forRoot(),
    LoaderModule,
    SharedModule,
    NgxDatatableModule,
    BsDatepickerModule.forRoot(),
    // TranslateModule.forRoot({
    //   loader: {
    //     provide: TranslateLoader,
    //     useFactory: HttpLoaderFactory,
    //     deps: [HttpClient]
    //   }
    // })
   // DemoRoutingModule
  ],
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    P403Component,
    P404Component,
    P500Component,
    LoginComponent,
    AccountActivateComponent,
    RegisterComponent,
    ResetPasswordComponent,
    CmsFrontComponent,
    SafeHtml,
    ConnectionListComponent,
    OrderConnectionListComponent,
    VerifyOTPComponent,
    AccountActiveTempComponent,
    BatchManagementComponent,
    OrdersExtendedModalComponent,
    InventoryExtendedModalComponent,
    PatientExtendedModalComponent,
    PurchaseExtendedModalComponent,
    ItemWiseMarginComponent,
    ItemwisepurchaseComponent,
    HospitalInactiveExtendedModalComponent,
    HeightvaluepatientHospitalComponent,
    // WhatsappManagementComponent,
   // DiagnosticManagementComponent,
    //LabsManagementComponent,
   // IpdManagementComponent,
   
  ],
  entryComponents: [ConnectionListComponent , OrderConnectionListComponent, BatchManagementComponent, OrdersExtendedModalComponent,InventoryExtendedModalComponent, PatientExtendedModalComponent, PurchaseExtendedModalComponent,ItemWiseMarginComponent,
    ItemwisepurchaseComponent,HospitalInactiveExtendedModalComponent,HeightvaluepatientHospitalComponent
  ],
  providers: [
    AuthGuard,
    { provide: LocationStrategy, useClass: HashLocationStrategy},
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }
